import React from 'react';
import { Col, Row } from 'reactstrap';

import ResourceProperty from '../../../../common/resource/ResourceProperty';
import TicketCorporateCreditInformationPropTypes from '../proptypes/TicketCorporateCreditInformationPropTypes';
import IsActive from '../../../../common/cells/IsActive';
import InternalResource from '../../../../common/resource/InternalResource';

import { CONTRACT_TYPE } from '../../../../../config/constants';
import { AGENCY_PATH } from '../../../../../config/paths';

const TicketCorporateCreditInformationResource = ({
  id,
  name,
  description,
  active,
  company,
  contractType,
  agencyId,
  creditDays,
  createDate,
  lastUpdate,
}) => {
  const contractInformationResource = (
    <>
      <h3>Información de Contrato</h3>

      {company && (
        <ResourceProperty label="Empresa:">{company.name}</ResourceProperty>
      )}

      <ResourceProperty label="Tipo de Contrato:">
        {contractType && CONTRACT_TYPE[contractType]
          ? CONTRACT_TYPE[contractType].label
          : '-'}
      </ResourceProperty>
      <ResourceProperty label="Crédito a (días):">
        {creditDays || '-'}
      </ResourceProperty>
      <ResourceProperty label="Agencia:">
        {agencyId ? (
          <a
            href={`${AGENCY_PATH}/${agencyId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir agencia
          </a>
        ) : (
          '-'
        )}
      </ResourceProperty>
    </>
  );

  const internalResource = (
    <InternalResource id={id} createDate={createDate} lastUpdate={lastUpdate} />
  );

  return (
    <>
      <h3>Información Básica</h3>

      <ResourceProperty label="Nombre:">{name}</ResourceProperty>

      <ResourceProperty label="Descripción:">
        {description || '-'}
      </ResourceProperty>

      <ResourceProperty label="Estado:">
        <IsActive value={active} />
      </ResourceProperty>

      <Row>
        <Col md={6}>{contractInformationResource}</Col>

        <Col md={6}>{internalResource}</Col>
      </Row>
    </>
  );
};

TicketCorporateCreditInformationResource.propTypes =
  TicketCorporateCreditInformationPropTypes;

export default TicketCorporateCreditInformationResource;
